import React from "react"
import { css } from 'emotion'
import Wp from '../images/wapp.svg';
import Logo40 from '../images/LOGO 40 AÑOS BLANCO.png'
import LogoIes from '../images/logo blanco.png';

const SectionContacto = () => {

  return (
    <section
      className={css`
        background-color: #1f517c;
        padding: 40px 40px 20px 40px;
        text-align: center;
        color: #fff;
      `}
    >
      <div className={css`
        @media all and (min-width: 600px) {
        display: flex;
        }

      `}>

        {/*
        <div className={css`
        margin: auto;
        `}>
          <img src={Logo40} alt="IES21"/>
        </div>

        */}


        <div className={css`
          margin: auto;
        `}>
          <img src={LogoIes} alt="IES21"/>
        </div>
        <div className={css`
        margin: auto;
         `}>
          <h3>Contacto</h3>
          <p>
        Directora del Departamento de Comunicación:
        <br />
        Pilar Lovaiza
        <br />
        <a href="mailto:plovaiza@ies21.edu.ar" className={css`color:#FFFFFF;`}>plovaiza@ies21.edu.ar</a>
        <br />
        <a
          className={css`
            color: #fff;
          `}
          href="https://api.whatsapp.com/send?phone=5493516784879"
          target="_blank"
          rel="noopener noreferrer"
        >
          351 6784879
        </a>
        <br />
      </p>
        </div>
      </div>

      <div className={css`
          display:none;
        `}>
      <h3>Contacto</h3>

      <div
        className={css`
          max-width: 33px;
          margin: auto;
          margin-top: 30px;
          display:none;
        `}
      >

      <a
          href="https://api.whatsapp.com/send?phone=5493516363639"
          target="_blank"
          rel="noopener noreferrer"
         className={css`display:none;`} >
          <img
                    src={Wp}
                    alt="WP"
                    className={css`
                        max-width: 33px;
                        width: 100%;
                    `}
                />
        </a>
      </div>
      <p>
        ViceDirectora del Departamento de Comunicación:
        <br />
        Pilar Lovaiza
        <br />
        <a href="mailto:plovaiza@ies21.edu.ar" className={css`color:#FFFFFF;`}>plovaiza@ies21.edu.ar</a>
        <br />
        <a
          className={css`
            color: #fff;
          `}
          href="https://api.whatsapp.com/send?phone=5493516784879"
          target="_blank"
          rel="noopener noreferrer"
        >
          351 6784879
        </a>
        <br />
      </p>
      </div>
    </section>
  )
}

export default SectionContacto
